<template>
    <section class="summary">
        <div class="summary__container container">
            <h1 class="valuation-layout__header">Free Instant Vehicle Valuation</h1>
            <StepBar />
            <StepLink :step="step - 1" />
            <h2 class="valuation__title">Your Summary</h2>
            <!-- <SignIn /> -->
            <div class="summary__flex">
                <div class="rd-card rd-card--border-top summary__card">
                    <div class="rd-card__inner">
                        <template v-if="showAuthenticatedForm">
                            <div class="login__logged-in">
                                <form @submit.prevent="submitValuationForm" id="logged-in" ref="form" method="post" class="material-form details-form summary__form" data-form-name="Valuation - Your Details" style="position: relative;">
                                    <ul class="validation-error__ul ul__no-bullet" v-if="newlyRegistered">
                                        <li class="validation-error__li validation-error--success">Your account has been created successfully</li>
                                    </ul>
                                    <div class="form-grid form-grid--xs-1-column">
                                        <h3 class="card__heading">Your Details:</h3>
                                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                            <title-input :readonly="true" />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <first-name :readonly="true" />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <last-name :readonly="true" />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <email :readonly="true" />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <telephone :inputNullable="false" inputValidateMessage="Please enter a telephone number" />
                                        </div>
                                        <div v-if="!useSpecificDealer" class="form-grid__col form-grid__col--xs-full-width">
                                            <customer-location />
                                        </div>
                                        <div v-if="!useSpecificDealer" class="form-grid__col form-grid__col--xs-full-width">
                                            <dealer :filter-dealers-by-brand="brand" />
                                        </div>
                                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                            <privacy />
                                        </div>
                                    </div>
                                    <template v-if="guest === true || authenticated === true">
                                        <button type="button" class="btn btn--primary btn--full-width  summary__button summary__button" @click.prevent="submitValuationForm">
                                            <span class="find-my-car__used-btn-txt">Continue</span>
                                        </button>
                                    </template>
                                </form>
                            </div>
                        </template>
                        <!-- if not logged in  -->
                        <template v-else>
                            <SignInOrGuestToggle :guest="guest" @toggle-guest="handleToggleGuest"> </SignInOrGuestToggle>
                            <!-- log in as guest -->
                            <template v-if="showGuestForm">
                                <form @submit.prevent="submitValuationForm" id="guest-form" ref="form" method="post" class="material-form details-form summary__form" data-form-name="Valuation - Your Details" style="position: relative;">
                                    <div v-if="statusMessage" class="validation-error__ul ul__no-bullet">
                                        <li class="validation-error__li validation-error--success">
                                            {{ statusMessage }}
                                        </li>
                                    </div>
                                    <div class="form-grid form-grid--xs-1-column">
                                        <h3 class="card__heading">Please complete your details below:</h3>
                                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                            <title-input />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <first-name />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <last-name />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <email />
                                        </div>
                                        <div class="form-grid__col form-grid__col--xs-full-width">
                                            <telephone :inputNullable="false" inputValidateMessage="Please enter a telephone number" />
                                        </div>
                                        <div v-if="!useSpecificDealer" class="form-grid__col form-grid__col--xs-full-width">
                                            <customer-location />
                                        </div>
                                        <div v-if="!useSpecificDealer" class="form-grid__col form-grid__col--xs-full-width">
                                            <dealer :filter-dealers-by-brand="brand" />
                                        </div>
                                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                            <privacy />
                                        </div>
                                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                                            <create-account @updateForm="updateValidatableElements" formType="valuation" />
                                        </div>
                                    </div>
                                    <template v-if="guest === true || authenticated === true">
                                        <button type="button" class="btn btn--primary btn--full-width  summary__button summary__button" @click.prevent="submitValuationForm">
                                            <span class="find-my-car__used-btn-txt">Continue</span>
                                        </button>
                                    </template>
                                </form>
                            </template>
                            <!-- log in screen -->
                            <template v-else>
                                <Login></Login>
                            </template>
                        </template>
                    </div>
                </div>
                <div class="summary__booking-overview">
                    <VehicleDetails />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { VehicleDetails, StepBar, StepLink } from "../index";
import TitleInput from "../../../core/components/Forms/Title.vue";
import FirstName from "../../../core/components/Forms/FirstName.vue";
import LastName from "../../../core/components/Forms/LastName.vue";
import Email from "../../../core/components/Forms/Email.vue";
import Telephone from "../../../core/components/Forms/Telephone.vue";
import CustomerLocation from "../../../core/components/Forms/CustomerLocation.vue";
import Dealer from "../../../core/components/Forms/Dealer.vue";
import CreateAccount from "../../../core/components/Forms/CreateAccount.vue";
import SignInOrGuestToggle from "../../../core/components/Auth/SignInOrGuestToggle.vue";
import Login from "../../../core/components/Auth/Login.vue";
import Privacy from "../../../core/components/Forms/Privacy.vue";
import CustomerLocationHandler from "../../../modules/CustomerLocationHandler.js";

export default {
    components: {
        SignInOrGuestToggle,
        Login,
        CreateAccount,
        VehicleDetails,
        StepBar,
        StepLink,
        TitleInput,
        FirstName,
        LastName,
        Email,
        Telephone,
        Dealer,
        CustomerLocation,
        Privacy,
    },

    data() {
        return {
            validator: false,
            guest: null,
            submitting: false,
            locationHandler: null,
            brand: null,
        };
    },

    watch: {
        showAuthenticatedForm(val) {
            if (val) {
                this.$nextTick(function () {
                    this.validator = new ContactFormValidator({
                        element: this.$refs['form'],
                        vueForm: true,
                        redesign: true,
                    });
                    this.locationHandler.setup(this.$refs['form']);
                });
            }
        },
        showGuestForm(val) {
            if (val) {
                this.$nextTick(function () {
                    this.validator = new ContactFormValidator({
                        element: this.$refs['form'],
                        vueForm: true,
                        redesign: true,
                    });
                    this.locationHandler.setup(this.$refs['form']);
                });
            }
        },
    },

    created() {
        if (window.brand && window.brand !== null  && window.brand !== '') {
            this.brand = window.brand;
        }
    },

    computed: {
        ...mapState("Auth", ['authenticated', 'vehicleRegistered', 'newlyRegistered', 'statusMessage']),
        ...mapState("ValuationTool", ['step', 'otherSelected', 'registration', 'mileage', 'useSpecificDealer']),

        showAuthenticatedForm() {
            if (this.authenticated === true && ((this.newlyRegistered && !this.submitting) || (!this.newlyRegistered))) {
                return true;
            }
            return false;
        },

        showGuestForm() {
            if (this.guest === true || (this.authenticated && this.newlyRegistered && this.submitting)) {
                return true;
            }
            return false;
        },

    },

    methods: {
        ...mapActions("ValuationTool", ['submitValuation', 'goToPosition']),

        updateValidatableElements() {
            this.$nextTick(function () {
                this.validator.updateValidatableElements();
            })
        },

        handleToggleGuest(guest) {
            this.guest = guest;
            this.$nextTick(function () {
                this.validator = new ContactFormValidator({
                    element: this.$refs['form'],
                    vueForm: true,
                    redesign: true,
                });
                this.locationHandler.setup(this.$refs['form']);
            })
        },

        handleSubmissionError(error) {
            console.error(error);
            // If we ended up authenticated after registering, then toggle us to the authenticated method
            if (this.authenticated) {
                this.handleToggleGuest(false);
                this.$nextTick(function () {
                    this.validator.errorResponse(error);
                    this.submitting = false;
                });
            } else {
                this.submitting = false;
            }
        },

        submitValuationForm() {
            if (this.submitting) {
                console.warn("Form is already submitting");
                return;
            }
            this.submitting = true;

            this.validator.validateAndSubmit(null, false, formData => {
                return new Promise((resolve, reject) => {
                    const vehicle = {
                        reg_no: this.registration,
                        mileage: this.mileage
                    };
                    formData.append('vehicle', JSON.stringify(vehicle));
                    formData.append('reg_no', this.registration);
                    formData.append('mileage', this.mileage);

                    if (formData.get("create-account") == "true") {
                        this.$store.dispatch('Auth/createAccount', formData)
                            .then(response => {
                                this.submitValuation(formData)
                                    .then(response => {
                                        resolve();
                                        this.submitting = false;
                                    })
                                    .catch(error => {
                                        this.handleSubmissionError(error);
                                        reject();
                                    });
                            })
                            .catch(error => {
                                this.handleSubmissionError(error);
                                reject();
                            });
                    } else {
                        this.submitValuation(formData)
                            .then(response => {
                                resolve();
                                this.submitting = false;
                            })
                            .catch(error => {
                                this.handleSubmissionError(error);
                                reject();
                            })
                    }
                });
            })
            .catch(error => {
                console.error('Validation failed');
                this.handleSubmissionError(error);
            });
        },
    },

    mounted() {
        this.goToPosition('valuation-start')

        this.validator = new ContactFormValidator({
            element: this.$refs['form'],
            vueForm: true,
            redesign: true,
        });

        this.locationHandler = new CustomerLocationHandler({
            element: this.$refs['form'],
            additionalLocationFilterFunction: dealer => (dealer.is_national_centre == 0 && dealer.offers_used == 'Y')
        });

        if (this.vehicleRegistered === true || this.authenticated) {
            this.guest = false;
        } else {
            this.guest = true;
        }
    },
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/used/search-results/login-modal";
</style>
